import React from 'react';
import styled from 'styled-components';
import { MEDICAL_QUESTIONS } from './healthProposalQuestion';
// import { axiosPOSTCall1 } from '../../../utilities/utils/apiPost'; // Uncomment if used

const Section = styled.div`
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-top: 30px;
`;

const Title = styled.h2`
  background-color: #f28c28;
  color: white;
  padding: 12px 20px;
  margin: -20px -20px 20px;
  font-size: 18px;
`;

const SubTitle = styled.h3`
  color: #f28c28;
  margin-bottom: 20px;
`;

const QuestionBlock = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

const ButtonSubmit = styled.button`
  margin-top: 10px;
  padding: 10px 25px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

const ButtonBack = styled.button`
  margin-top: 10px;
  margin-right: 10px;
  padding: 10px 25px;
  background-color: rgb(240, 40, 40);
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
`;

// new toggles
const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

const ToggleLabel = styled.label`
  font-weight: 600;
  margin-right: 10px;
  user-select: none;
`;

const ToggleSwitch = styled.input.attrs({ type: 'checkbox' })`
  position: relative;
  width: 50px;
  height: 26px;
  appearance: none;
  outline: none;
  background: #c6c6c6;
  border-radius: 30px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: background 0.3s;

  &:checked {
    background: #f28c28;
  }

  &:before {
    content: '';
    position: absolute;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    top: 2px;
    left: 2px;
    background: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    transition: 0.3s;
  }

  &:checked:before {
    left: calc(100% - 24px);
  }
`;

const MedicalHistory = ({
  values = {},
  setValues,
  slug,
  onBack,
  onContinue,
  septateCombinedRedux,
}) => {
  const insuredMembers = septateCombinedRedux.insuredMembers || {};
  const questions = MEDICAL_QUESTIONS[slug].questions || [];
  const validationRules = MEDICAL_QUESTIONS[slug]?.validationRules || {};

  // const getDynamicKey = (memberKey, relation) => {
  //   if (memberKey === 'child' && relation) {
  //     return `proposalMedicalQuestion_${relation.toLowerCase()}`;
  //   }
  //   return memberKey;
  // };

  // const handleChange = (memberKey, index, question, member) => (e) => {
  //   const selectedValue = e.target.value;

  //   // Get current answer to revert if needed
  //   const currentAnswer = getAnswer(memberKey, index, question.key, member);

  //   // Check if selection violates validation rules
  //   if (
  //     (validationRules.regretIfYes?.includes(question.key) &&
  //       selectedValue === 'Yes') ||
  //     (validationRules.regretIfNo?.includes(question.key) &&
  //       selectedValue === 'No')
  //   ) {
  //     alert(
  //       'Regret, policy cannot be issued online. Please contact our nearest branch.'
  //     );
  //     // Do NOT update the value — revert to previous answer by returning early
  //     return;
  //   }

  //   // if (memberKey === 'child') {
  //   //   const children = [...(insuredMembers.child || [])];
  //   //   const child = children[index];

  //   //   const updatedAnswers = (child.proposalMedicalQuestion || []).filter(
  //   //     (q) => q.key !== question.key
  //   //   );

  //   //   const newAnswer = { key: question.key, answer: e.target.value };

  //   //   children[index] = {
  //   //     ...child,
  //   //     proposalMedicalQuestion: [...updatedAnswers, newAnswer],
  //   //   };

  //   //   setValues((prev) => ({
  //   //     ...prev,
  //   //     insuredMembers: {
  //   //       ...insuredMembers,
  //   //       child: children,
  //   //     },
  //   //   }));
  //   // } else {
  //   //   const prev = values?.proposalMedicalQuestion || {};
  //   //   const updatedAnswers = (prev[memberKey] || []).filter(
  //   //     (q) => q.key !== question.key
  //   //   )

  //     if (memberKey === 'child') {
  //       const prevPMQ = values.proposalMedicalQuestion || {};
  //       const prevChildAnswers = prevPMQ.child || [];
  //       const currentChildAnswers = prevChildAnswers[index] || [];

  //       const updatedAnswers = currentChildAnswers.filter(
  //         (q) => q.key !== question.key
  //       );
  //       const newAnswers = [
  //         ...updatedAnswers,
  //         { key: question.key, answer: selectedValue },
  //       ];

  //       const updatedChildAnswers = [...prevChildAnswers];
  //       updatedChildAnswers[index] = newAnswers;
  //       console.log("🚀 ~ updatedChildAnswers:", updatedChildAnswers)

  //       setValues((prev) => ({
  //         ...prev,
  //         proposalMedicalQuestion: {
  //           ...prevPMQ,
  //           child: updatedChildAnswers,
  //         },

  //       }));

  //     } else {
  //       const prev = values?.proposalMedicalQuestion || {};
  //       const updatedAnswers = (prev[memberKey] || []).filter(
  //         (q) => q.key !== question.key
  //       );
  //     const newAnswer = { key: question.key, answer: selectedValue };

  //     console.log("🚀 ~ handleChange ~ memberKey:", memberKey)
  //     setValues({
  //       ...values,
  //       proposalMedicalQuestion: {
  //         ...prev,
  //         [memberKey]: [...updatedAnswers, newAnswer],
  //       },
  //     });
  //   }
  // };

  // const getAnswer = (memberKey, index, key, member) => {
  //   if (memberKey === 'child') {
  //     const childAnswers = values.proposalMedicalQuestion?.child?.[index] || [];
  //     const found = childAnswers.find((q) => q.key === key);
  //     return found ? found.answer : '';
  //   }
  //   const memberAnswers = values?.proposalMedicalQuestion?.[memberKey] || [];
  //   const found = memberAnswers.find((q) => q.key === key);
  //   return found ? found.answer : '';
  // };

  const renderMemberSection = (member, index, memberKey, firstName) => {

    const relation = member.relation?.toLowerCase?.();
    const memberTitle =
      member.relation?.charAt(0).toUpperCase() + member.relation?.slice(1) ||
      'Member';

    const allYes = questions.every(
      (q) => getAnswer(memberKey, index, q.key, relation) === 'Yes'
    );

    return (
      <Section key={`${memberKey}_${index ?? ''}`}>
        <Title>{memberTitle}</Title>
        <SubTitle>Medical History</SubTitle>

        <ToggleWrapper>
          <ToggleLabel>
            {allYes ? 'Set All to No' : 'Set All to Yes'}
          </ToggleLabel>
          <ToggleSwitch
            checked={allYes}
            onChange={(e) =>
              handleSelectAll(memberKey, index, e.target.checked ? 'Yes' : 'No')
            }
          />
        </ToggleWrapper>

        {questions.map((question) => (
          <QuestionBlock key={`${memberKey}_${index ?? ''}_${question.key}`}>
            <Label>{question.text}</Label>
            <RadioGroup>
              <label>
                <input
                  type="radio"
                  name={`${memberKey}_${index ?? ''}_${question.key}`}
                  value="Yes"
                  checked={
                    getAnswer(memberKey, index, question.key, relation) ===
                    'Yes'
                  }
                  onChange={handleChange(memberKey, index, question, relation, firstName)}
                />{' '}
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name={`${memberKey}_${index ?? ''}_${question.key}`}
                  value="No"
                  checked={
                    getAnswer(memberKey, index, question.key, relation) === 'No'
                  }
                  onChange={handleChange(memberKey, index, question, relation, firstName)}
                />{' '}
                No
              </label>
            </RadioGroup>
          </QuestionBlock>
        ))}
      </Section>
    );
  };

  const handleChange = (memberKey, index, question, relation, firstName) => (e) => {
    const selectedValue = e.target.value;
    const key = `${memberKey}_${firstName}_${relation}`; 

    if (
      (validationRules.regretIfYes?.includes(question.key) &&
        selectedValue === 'Yes') ||
      (validationRules.regretIfNo?.includes(question.key) &&
        selectedValue === 'No')
    ) {
      alert(
        'Regret, policy cannot be issued online. Please contact our nearest branch.'
      );
      return;
    }

    setValues((prev) => {
      const members = { ...(prev.insuredMembers || {}) };

      if (memberKey === 'child') {
        const children = [...(members.child || [])];
        const child = { ...(children[index] || {}) };

        const prevAnswers = child.proposalMedicalQuestion || [];

        const updatedAnswers = [
          ...prevAnswers.filter((q) => q.key !== question.key),
          { key: question.key, answer: selectedValue },
        ];

        const isSmokeAnswer = selectedValue === 'Yes' && question.key === 'Q8';

        children[index] = {
          ...child,
          proposalMedicalQuestion: updatedAnswers,
          uniqueKey: key, // optional store unique key if needed
          isSmoke: isSmokeAnswer,
        };

        members.child = children;
      } else {
        const member = { ...(members[memberKey] || {}) };
        const prevAnswers = member.proposalMedicalQuestion || [];

        const updatedAnswers = [
          ...prevAnswers.filter((q) => q.key !== question.key),
          { key: question.key, answer: selectedValue },
        ];

        const isSmokeAnswer = selectedValue === 'Yes' && question.key === 'Q8';

        
        members[memberKey] = {
          ...member,
          proposalMedicalQuestion: updatedAnswers,
          isSmoke: isSmokeAnswer,
        };
      }

      return {
        ...prev,
        insuredMembers: members,
      };
    });
  };
  
  const handleSelectAll = (memberKey, index, value) => {
    const allAnswers = questions.map((q) => ({ key: q.key, answer: value }));

    const isSmokeAnswer =
      value === 'Yes' && questions.some((q) => q.key === 'Q8');

    setValues((prev) => {
      const members = { ...(prev.insuredMembers || {}) };

      if (memberKey === 'child') {
        const children = [...(members.child || [])];
        const child = { ...(children[index] || {}) };

        children[index] = {
          ...child,
          proposalMedicalQuestion: allAnswers,
          uniqueKey: `${memberKey}_${index}`, 
          isSmoke: isSmokeAnswer,
        };

        members.child = children;
      } else {
        const member = { ...(members[memberKey] || {}) };

        members[memberKey] = {
          ...member,
          proposalMedicalQuestion: allAnswers,
          isSmoke: isSmokeAnswer,
        };
      }

      return {
        ...prev,
        insuredMembers: members,
      };
    });
  };

  const getAnswer = (memberKey, index, key) => {
    if (memberKey === 'child') {
      const child = values.insuredMembers?.child?.[index];
      return (
        child?.proposalMedicalQuestion?.find((q) => q.key === key)?.answer || ''
      );
    }

    const member = values.insuredMembers?.[memberKey];
    return (
      member?.proposalMedicalQuestion?.find((q) => q.key === key)?.answer || ''
    );
  };
  

  // const handleSelectAll = (memberKey, index, value) => {
  //   if (memberKey === 'child') {
  //     const prevPMQ = values.proposalMedicalQuestion || {};
  //     const prevChildAnswers = prevPMQ.child || [];
  //     const allAnswers = questions.map((q) => ({ key: q.key, answer: value }));

  //     const updatedChildAnswers = [...prevChildAnswers];
  //     updatedChildAnswers[index] = allAnswers;

  //     setValues((prev) => ({
  //       ...prev,
  //       proposalMedicalQuestion: {
  //         ...prevPMQ,
  //         child: updatedChildAnswers,
  //       },
  //     }));
  //   } else {
  //     const prev = values?.proposalMedicalQuestion || {};
  //     const allAnswers = questions.map((q) => ({ key: q.key, answer: value }));
  //     setValues({
  //       ...values,
  //       proposalMedicalQuestion: {
  //         ...prev,
  //         [memberKey]: allAnswers,
  //       },
  //     });
  //   }
  // };



  // Validation logic to disable Submit button
  const regretIfYesKeys = validationRules.regretIfYes || [];
  const regretIfNoKeys = validationRules.regretIfNo || [];

  const allAnswers = [];

  if (values.insuredMembers) {
    for (const memberKey in values.insuredMembers) {
      if (memberKey === 'child') {
        const children = values.insuredMembers.child || [];
        children.forEach((child, childIndex) => {
          const answers = child.proposalMedicalQuestion || [];
          answers.forEach((ans) => {
            allAnswers.push({ ...ans, memberKey, childIndex });
          });
        });
      } else {
        const member = values.insuredMembers[memberKey];
        const answers = member?.proposalMedicalQuestion || [];
        answers.forEach((ans) => {
          allAnswers.push({ ...ans, memberKey });
        });
      }
    }
  }


  const isSubmitDisabled = allAnswers.some(
    (ans) =>
      (regretIfYesKeys.includes(ans.key) && ans.answer === 'Yes') ||
      (regretIfNoKeys.includes(ans.key) && ans.answer === 'No')
  );

  // Message to show when submit disabled
  const declinedReasonsByMember = allAnswers
    .filter(
      (ans) =>
        (regretIfYesKeys.includes(ans.key) && ans.answer === 'Yes') ||
        (regretIfNoKeys.includes(ans.key) && ans.answer === 'No')
    )
    .reduce((acc, { memberKey, key, answer, childIndex }) => {
      const memberData =
        memberKey === 'child'
          ? insuredMembers.child?.[childIndex] // <-- Use correct child index here
          : insuredMembers[memberKey];

      const memberName =
        memberData?.firstName && memberData?.lastName
          ? `${memberData.firstName} ${memberData.lastName}`
          : memberKey;

      const questionText = questions.find((q) => q.key === key)?.text || key;

      let expectedAnswer = regretIfYesKeys.includes(key)
        ? 'No'
        : regretIfNoKeys.includes(key)
        ? 'Yes'
        : '';

      const message = `You selected "${answer}" but it should be "${expectedAnswer}" for question "${key}" (${questionText})`;

      if (!acc[memberName]) acc[memberName] = [];
      acc[memberName].push(message);

      return acc;
    }, {});

  return (
    <>
      {insuredMembers.self &&
        renderMemberSection(insuredMembers.self, null, 'self')}
      {insuredMembers.spouse &&
        renderMemberSection(insuredMembers.spouse, null, 'spouse')}
      {insuredMembers.parent &&
        renderMemberSection(insuredMembers.parent, null, 'parent')}
      {insuredMembers.inLaws &&
        renderMemberSection(insuredMembers.inLaws, null, 'inLaws')}
      {Array.isArray(insuredMembers.child) &&
        insuredMembers.child.map((child, index) =>
          renderMemberSection(child, index, 'child', child.firstName)
        )}

      <div style={{ marginTop: '20px' }}>
        <ButtonBack onClick={onBack}>Back</ButtonBack>
        <ButtonSubmit onClick={onContinue} disabled={isSubmitDisabled}>
          Submit
        </ButtonSubmit>
      </div>

      {isSubmitDisabled && (
        <div style={{ marginTop: '15px', fontWeight: 'bold', color: 'red' }}>
          Regret, policy cannot be issued online. Please contact our nearest
          branch.
          <br />
          <br />
          <strong>Reasons:</strong>
          <br />
          {Object.entries(declinedReasonsByMember).map(
            ([memberName, reasons]) => (
              <div
                key={memberName}
                style={{
                  marginBottom: '1rem',
                  padding: '10px',
                  border: '1px solid #f28c28',
                  borderRadius: '6px',
                }}
              >
                <div
                  style={{
                    fontWeight: 'bold',
                    marginBottom: '5px',
                    color: '#000',
                  }}
                >
                  {memberName}:
                </div>
                <ul style={{ margin: 0, paddingLeft: '20px' }}>
                  {reasons.map((reason, i) => (
                    <li key={i}>{reason}</li>
                  ))}
                </ul>
              </div>
            )
          )}
        </div>
      )}
    </>
  );
};

export default MedicalHistory;